
import React from 'react';
import { useFasting } from '@/contexts/FastingContext';
import { Flame } from 'lucide-react';

export const CaloriesBurned: React.FC = () => {
  const { estimatedCaloriesBurned } = useFasting();
  
  // Calculate fat loss (1 pound of fat = 3500 calories)
  const fatLossPounds = estimatedCaloriesBurned / 3500;
  const fatLossDisplay = fatLossPounds < 0.01 
    ? '< 0.01' 
    : fatLossPounds.toFixed(2);
  
  return (
    <div className="flex flex-col items-center justify-center gap-2 mb-4">
      <div className="flex items-center gap-2">
        <div className="relative">
          <Flame className="h-5 w-5 text-orange-500" />
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="h-2 w-2 bg-orange-300 rounded-full animate-ping"></div>
          </div>
        </div>
        <span className="text-muted-foreground text-sm">Est. calories burned:</span>
        <span className="font-bold text-orange-500">{estimatedCaloriesBurned}</span>
      </div>
      <div className="text-xs text-muted-foreground">
        Approx. fat loss: <span className="font-medium text-orange-500">{fatLossDisplay}</span> lbs
      </div>
    </div>
  );
};
